import { LOADED } from "../types";

export default function loaded(state = { loaded: false}, action = {}) {
  switch (action.type) {
    case LOADED:
      return { ...state, ...action.loaded };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/loaded.js